module.exports = __webpack_public_path__ + "img/i_search_g.e212fa12.svg";